import { render, staticRenderFns } from "./MtCreditConfig.vue?vue&type=template&id=bae3d9b6&scoped=true&"
import script from "./MtCreditConfig.vue?vue&type=script&lang=js&"
export * from "./MtCreditConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae3d9b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bae3d9b6')) {
      api.createRecord('bae3d9b6', component.options)
    } else {
      api.reload('bae3d9b6', component.options)
    }
    module.hot.accept("./MtCreditConfig.vue?vue&type=template&id=bae3d9b6&scoped=true&", function () {
      api.rerender('bae3d9b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/MtCreditConfig.vue"
export default component.exports